import { render, staticRenderFns } from "./OrgPost.vue?vue&type=template&id=530012f8&scoped=true&"
import script from "./OrgPost.vue?vue&type=script&lang=js&"
export * from "./OrgPost.vue?vue&type=script&lang=js&"
import style0 from "./OrgPost.vue?vue&type=style&index=0&id=530012f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530012f8",
  null
  
)

export default component.exports